import Vue from 'vue'
import Router from 'vue-router'
import Hello from '@/components/Hello'
import SignUp from '@/components/SignUp'
import Plans from '@/components/Plans'
import Topic from '@/components/Topic'
import Validate from '@/components/Validate'
import Join from '@/components/Join'
import InterestList from '@/components/InterestList'
import ResetPassword from '@/components/ResetPassword'
import UnAuth from '@/components/UnAuth'
import Experts from '@/components/Experts'
import ManagePage from '@/components/ManagePage'
import EmailRules from '@/components/EmailRules'
// import Career from '@/components/Career'
import Expert from '@/components/Expert'
import Player from '@/components/VideoPlayer'
import Charities from '@/components/Charities'
import Search from '@/components/Search'
import Giving from '@/components/Giving'
import Profile from '@/components/Profile'
import Community from '@/components/Community'
import LiveEvent from '@/components/LiveEvent'
import NewCareer from '@/components/NewCareer'
import Inspiration from '@/components/Inspiration'
import Mindbody from '@/components/Mindbody'
import ContactUs from '@/components/ContactUs'
import AboutUs from '@/components/AboutUs'
import Feedback from '@/components/Feedback'
import Terms from '@/components/Terms'
import PrivacyPolicy from '@/components/PrivacyPolicy'
import Work from '@/components/Work'
import Money from '@/components/Money'
import Life from '@/components/Life'
import RecentlyWatched from '@/components/RecentlyWatched'
import RelatedVideos from '@/components/RelatedVideo'
import Rules from '@/components/Rules'
import Talk from '@/components/Talk'
import Rating from '@/components/Rating'
import store from '../store'
import LiveStreamTest from '@/components/LiveStreamTest'
import Gift from '@/components/Gift'
import Redeem from '@/components/Redeem'
import Gifts from '@/components/Gifts'
import PodcastTone from '@/components/PodcastTone'
import FAQ from '@/components/FAQ'
import Event from '@/components/Event'
import CorporateGift from '@/components/CorporateGift'
import TrialExpiry from '@/components/TrialExpiry'
import TrialExpiryNovo from '@/components/TrialExpiry_Novo'
import AccentureCharlotte from '@/components/AccentureCharlot'
import CorporationGifting from '@/components/CorporationGifting'
import CorporationGiftingComcast from '@/components/CorporationGiftingComcast'
import UnauthPlayer from '@/components/UnauthVideoPlayer'
import NewEvents from '@/components/NewEvents'
import CorporationReferral from '@/components/CorporationReferral'
import PlaylistVideoPlayer from '@/components/PlaylistVideoPlayer'
import CorpPlaylistVideoPlayer from '@/components/CorpPlaylistVideoPlayer'
import TrendingPlaylistVideoPlayer from '@/components/TrendingPlaylist'
import PressRelease from '@/components/PressRelease'
import CorporateSale from '@/components/CorporateSale'
// import Contents from '@/components/Contents'
import WorkContents from '@/components/WorkContents'
import LifeContents from '@/components/LifeContents'
import MindbodyContents from '@/components/MindbodyContents'
import MoneyContents from '@/components/MoneyContents'
import B2b from '@/components/B2B'
import ArchivePlayer from '@/components/ArchivePlaylistPlayer'
import SharePlayer from '@/components/SharePlaylistPlayer'
import drRamani from '@/components/DrRamani'
import JoinNowMobile from '@/components/JoinNowMobile'
import Logout from '@/components/Logout'
import Takeaway from '@/components/TakeawayMobile'
import Teaser from '@/components/TeaserMobile'
import AMCEvent from '@/components/CorporateLiveEvent'
import SetTONE from '@/components/SetTone'
import ToneResources from '@/components/Resources'
import Maintainance from '@/components/Maintainance'
import CorporateCommunity from '@/components/CorporateCommunity'
import DemoEvent from '@/components/DemoEvent'
import CommunityDemo from '@/components/CommunityDemo'
import LiveEventDemo from '@/components/LiveEventDemo'
import BecomeExpert from '@/components/BecomeExpert'
import GiftRedirect from '@/components/GiftRedirect'
import { dateHelpers } from '../helpers/dateHelpers.js'
import Meta from 'vue-meta'

// import ga from 'vue-ga'
Vue.use(Router)
Vue.use(Meta, {
    keyName: 'metaInfo', // the component option name that vue-meta looks for meta info on.
    attribute: 'data-vue-meta', // the attribute name vue-meta adds to the tags it observes
    ssrAttribute: 'data-vue-meta-server-rendered', // the attribute name that lets vue-meta know that meta info has already been server-rendered
    tagIDKeyName: 'vmid' // the property name that vue-meta uses to determine whether to overwrite or append a tag
})
const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/mytone',
            name: 'Hello',
            component: Hello,
            meta: { title: 'Tone - Home' }
        },
        {
            path: '/g/:giftCode',
            name: 'GiftRedirect',
            component: GiftRedirect,
            meta: { title: 'Tone - Welcome!' }
        },
        {
            path: '/',
            name: 'UnAuth',
            component: B2b,
            meta: { title: 'Tone - Welcome!' }
        },
        {
            path: '/preferences?params=:params',
            name: 'EmailRules',
            component: EmailRules,
            meta: { title: 'Tone | Email Preferences' }
        },
        {
            path: '/preferences',
            name: 'EmailRules',
            component: EmailRules,
            meta: { title: 'Tone | Email Preferences' }
        },
        {
            path: '/plan/:planId',
            name: 'UnAuth',
            component: UnAuth,
            meta: { title: 'Tone - Welcome!' }
        },
        {
            path: '/corporation/:corporateId/:giftCode',
            name: 'UnAuth',
            component: UnAuth,
            meta: { title: 'Tone - Welcome!' }
        },
        {
            path: '/corporation/referral/:corporateId/:giftCode',
            name: 'ReferralUnAuth',
            component: UnAuth,
            meta: { title: 'Tone - Welcome!' }
        },
        {
            path: '/signup',
            name: 'SignUp',
            component: SignUp,
            meta: {
                title: 'Tone - Signup',
                hideNav: false
            }
        },
        {
            path: '/signup/:planId',
            name: 'SignUp',
            component: SignUp,
            meta: {
                title: 'Tone - Signup to your favorite plan',
                hideNav: false
            }
        },
        {
            path: '/plans',
            name: 'Plans',
            component: Plans,
            meta: { title: 'Tone - Plans' }
        },
        {
            path: '/topic',
            name: 'Topic',
            component: Topic
        },
        {
            path: '/validate',
            name: 'Validate',
            component: Validate,
            meta: {
                title: 'Tone - Validate Account',
                hideNav: false
            }
        },
        {
            path: '/validate?params=:params',
            name: 'Validate',
            component: Validate,
            meta: {
                title: 'Tone - Validate Account via Link',
                hideNav: false
            }
        },
        {
            path: '/join',
            name: 'Join',
            component: Join
        },
        {
            path: '/interests',
            name: 'InterestList',
            component: InterestList,
            meta: { title: 'Tone - Interests', hideNav: true }
        },
        {
            path: '/resetpassword',
            name: 'ResetPassword',
            component: ResetPassword,
            meta: {
                title: 'Tone - Reset Password',
                hideNav: false
            }
        },
        {
            path: '/resetpassword?params=:params',
            name: 'ResetPassword',
            component: ResetPassword,
            meta: {
                title: 'Tone - Reset Password',
                hideNav: false
            }
        },
        {
            path: '/career',
            name: 'Career',
            component: NewCareer,
            meta: { title: 'Tone - Career' }
        },
        {
            path: '/expert/:expertId',
            name: 'Expert',
            component: Expert,
            meta: { title: 'Tone - Expert' }
        },
        {
            path: '/expert/:expertId/:expertName',
            name: 'Expert',
            component: Expert,
            meta: { title: 'Tone - Expert' }
        },
        {
            path: '/watch/:videoCode',
            name: 'Player',
            component: Player,
            meta: { title: 'Tone - Video Player' }
        },
        {
            path: '/watch/:videoCode/:videoTitle',
            name: 'Player',
            component: Player,
            meta: { title: 'Tone - Video Player' }
        },
        {
            path: '/watch/:videoCode/:refBy',
            name: 'Player',
            component: Player,
            meta: { title: 'Tone - Video Player' }
        },
        {
            path: '/watch/:videoCode/:refBy/:videoTitle',
            name: 'Player',
            component: Player,
            meta: { title: 'Tone - Video Player' }
        },
        {
            path: '/search',
            name: 'Search',
            component: Search,
            meta: { title: 'Tone - Search' }
        },
        {
            path: '/search/:qryString',
            name: 'Search',
            component: Search,
            meta: { title: 'Tone - Search Results' }
        },
        {
            path: '/giving',
            name: 'Giving',
            component: Giving,
            meta: { title: 'Tone - Giving' }
        },
        {
            path: '/profile',
            name: 'Profile',
            component: Profile,
            meta: { title: 'Tone - Profile' }
        },
        {
            path: '/profile/:feature',
            name: 'Profile',
            component: Profile,
            meta: { title: 'Tone - Profile' }
        },
        {
            path: '/events',
            name: 'Events',
            component: Community,
            meta: { title: 'Tone - Events' }
        },
        {
            path: '/events/section/:section',
            name: 'Events',
            component: Community,
            meta: { title: 'Tone - Events' }
        },
        {
            path: '/liveevent/:eventId',
            name: 'LiveEvent',
            component: LiveEvent,
            meta: { title: 'Tone - Live Events' }
        },
        {
            path: '/charity/:charityId',
            name: 'Charities',
            component: Charities,
            meta: { title: 'Tone - View Charity' }
        },
        {
            path: '/inspiration',
            name: 'Inspiration',
            component: Inspiration,
            meta: { title: 'Tone - Inspiration Videos' }
        },
        {
            path: '/mindbody',
            name: 'Mindbody',
            component: Mindbody,
            meta: { title: 'Tone - Mindbody Videos' }
        },
        {
            path: '/work',
            name: 'Work',
            component: Work,
            meta: { title: 'Tone - Work Videos' }
        },
        {
            path: '/life',
            name: 'Life',
            component: Life,
            meta: { title: 'Tone - Life Videos' }
        },
        {
            path: '/money',
            name: 'Money',
            component: Money,
            meta: { title: 'Tone - Money Videos' }
        },
        {
            path: '/contactus',
            name: 'ContactUs',
            component: ContactUs,
            meta: { title: 'Tone - Contact Us' }
        },
        {
            path: '/business',
            name: 'B2b',
            component: B2b,
            meta: { title: 'Tone - TONE for Businesses' }
        },
        {
            path: '/b2b',
            name: 'B2b',
            component: B2b,
            meta: { title: 'Tone - TONE for Businesses' }
        },
        {
            path: '/aboutus',
            name: 'AboutUs',
            component: AboutUs,
            meta: { title: 'Tone - About Us' }
        },
        {
            path: '/pressrelease',
            name: 'PressRelease',
            component: PressRelease,
            meta: { title: 'Tone - Press Releases' }
        },
        {
            path: '/feedback',
            name: 'Feedback',
            component: Feedback,
            meta: { title: 'Tone - Feedback' }
        },
        {
            path: '/terms',
            name: 'Terms',
            component: Terms,
            meta: { title: 'Tone - Terms' }
        },
        {
            path: '/faq',
            name: 'FAQ',
            component: FAQ,
            meta: { title: 'Tone - FAQ' }
        },
        {
            path: '/privacypolicy',
            name: 'PrivacyPolicy',
            component: PrivacyPolicy,
            meta: { title: 'Tone - Privacy Policy' }
        },
        {
            path: '/recenltywatchedvideos',
            name: 'RecentlyWatched',
            component: RecentlyWatched,
            meta: { title: 'Tone - Recently Watched Videos' }
        },
        {
            path: '/relatedvideos',
            name: 'RelatedVideos',
            component: RelatedVideos,
            meta: { title: 'Tone - Related Videos' }
        },
        {
            path: '/rules/:eventId',
            name: 'Rules',
            component: Rules,
            meta: { title: 'Tone - Rules' }
        },
        {
            path: '/talk/:eventId',
            name: 'Talk',
            component: Talk,
            meta: { title: 'Tone - Talk' }
        },
        {
            path: '/rating',
            name: 'Rating',
            component: Rating,
            meta: { title: 'Tone - Rating' }
        },
        {
            path: '/experts',
            name: 'Experts',
            component: Experts,
            meta: {
                title: 'Tone - Experts',
                hideNav: false
            }
        },
        {
            path: '/lstest',
            name: 'LiveStreamTest',
            component: LiveStreamTest,
            meta: {
                title: 'Tone - LS Test',
                hideNav: false
            }
        },
        {
            path: '/sendgift',
            name: 'Gift',
            component: Gift,
            meta: {
                title: 'Tone - Send Gifts',
                hideNav: false
            }
        },
        {
            path: '/gifts',
            name: 'Gifts',
            component: Gifts,
            meta: {
                title: 'Tone - Gifts',
                hideNav: false
            }
        },
        {
            path: '/redeem',
            name: 'Redeem,',
            component: Redeem,
            meta: {
                title: 'Tone - Redeem Your Gift',
                hideNav: false
            }
        },
        {
            path: '/event',
            name: 'Event',
            component: Event,
            meta: {
                title: 'Tone - Event Details',
                hideNav: false
            }
        },
        {
            path: '/corporation/sale',
            name: 'CorporateSale',
            component: CorporateSale,
            meta: {
                title: 'Tone - Corporate Sale',
                hideNav: false
            }
        },
        {
            path: '/event/:eventId',
            name: 'Event',
            component: Event,
            meta: {
                title: 'Tone - Event Details',
                hideNav: false
            }
        },
        {
            path: '/corporategifts',
            name: 'CorporateGift',
            component: CorporateGift,
            meta: {
                title: 'Tone - Corporate Gifting',
                hideNav: false
            }
        },
        {
            path: '/becomemember',
            name: 'TrialExpiry',
            component: TrialExpiry,
            meta: {
                title: 'Tone - Become a Member',
                hideNav: false
            }
        },
        {
            path: '/become-member-novo',
            name: 'TrialExpiryNovo',
            component: TrialExpiryNovo,
            meta: {
                title: 'Tone - Become a Member',
                hideNav: false
            }
        },
        {
            path: '/accenturecharlotte',
            name: 'AccentureCharlotte',
            component: AccentureCharlotte,
            meta: {
                title: 'Tone - Accenture & Partners',
                hideNav: true
            }
        },
        {
            path: '/corporationgifting/:corporateId/:giftCode',
            name: 'CorporationGifting',
            component: CorporationGifting,
            meta: {
                title: 'Tone - Redeem Corporation Gifts',
                hideNav: false
            }
        },
        {
            path: '/corporationgifting/:corporateId/:giftCode/:regions',
            name: 'CorporationGiftingComcox',
            component: CorporationGifting,
            meta: {
                title: 'Tone - Redeem Corporation Gifts',
                hideNav: false
            }
        },
        {
            // path: '/corporationgiftingcomcast/:corporateId/:giftCode',
            path: '/corporationgiftingcustom/:corporateId/:giftCode',
            name: 'CorporationGiftingComcast',
            component: CorporationGiftingComcast,
            meta: {
                title: 'Tone - Redeem Corporation Gifts',
                hideNav: false
            }
        },
        {
            path: '/corporation/referral/buy/:corporateId/:giftCode',
            name: 'CorporationReferral',
            component: CorporationReferral,
            meta: {
                title: 'Tone - TONE Corporation Referral',
                hideNav: false
            }
        },
        {
            path: '/contentvideos/play/:videoCode',
            name: 'UnauthPlayer',
            component: UnauthPlayer,
            meta: {
                title: 'Tone - Watch Video',
                hideNav: false
            }
        },
        {
            path: '/contentvideos/play/:videoCode/:videoTitle',
            name: 'UnauthPlayer',
            component: UnauthPlayer,
            meta: {
                title: 'Tone - Watch Video',
                hideNav: false
            }
        },
        {
            path: '/contentvideos/play/:videoCode/:refBy',
            name: 'UnauthPlayer',
            component: UnauthPlayer,
            meta: {
                title: 'Tone - Watch Video',
                hideNav: false
            }
        },
        {
            path: '/contentvideos/play/:videoCode/:refBy/:videoTitle',
            name: 'UnauthPlayer',
            component: UnauthPlayer,
            meta: {
                title: 'Tone - Watch Video',
                hideNav: false
            }
        },
        {
            path: '/newevents/:eventId',
            name: 'NewEvents',
            component: NewEvents,
            meta: {
                title: 'Tone - New Events',
                hideNav: false
            }
        },
        {
            path: '/newevents',
            name: 'NewEvents',
            component: NewEvents,
            meta: {
                title: 'Tone - New Events',
                hideNav: false
            }
        },
        {
            path: '/playlist/:playlistId/play/:videoCode',
            name: 'PlaylistVideoPlayer',
            component: PlaylistVideoPlayer,
            meta: {
                title: 'Tone - Playlist',
                hideNav: false
            }
        },
        {
            path: '/playlist/trending/:playlistId/play/:videoCode',
            name: 'TrendingPlaylistVideoPlayer',
            component: TrendingPlaylistVideoPlayer,
            meta: {
                title: 'Tone - Trending Playlist',
                hideNav: false
            }
        },
        {
            path: '/playlist/trending/:playlistId/play/:videoCode/:videoTitle',
            name: 'TrendingPlaylistVideoPlayer',
            component: TrendingPlaylistVideoPlayer,
            meta: {
                title: 'Tone - Trending Playlist',
                hideNav: false
            }
        },
        {
            path: '/playlist/:playlistId/play/:videoCode/:corporationId',
            name: 'CorpPlaylistVideoPlayer',
            component: CorpPlaylistVideoPlayer,
            meta: {
                title: 'Tone - Playlist',
                hideNav: false
            }
        },
        {
            path: '/playlist/:playlistId/play/:videoCode/:corporationId/:videoTitle',
            name: 'CorpPlaylistVideoPlayer',
            component: CorpPlaylistVideoPlayer,
            meta: {
                title: 'Tone - Playlist',
                hideNav: false
            }
        },
        {
            path: '/tonearchive/:eventId/play/:sequence',
            name: 'ArchivePlayer',
            component: ArchivePlayer,
            meta: {
                title: 'Tone - Event Archive',
                hideNav: false
            }
        },
        {
            path: '/tonearchive/:eventId/play/:sequence/:eventTitle',
            name: 'ArchivePlayer',
            component: ArchivePlayer,
            meta: {
                title: 'Tone - Event Archive',
                hideNav: false
            }
        },
        {
            path: '/playlistshare/:playlistId/play/:videoCode',
            name: 'SharePlayer',
            component: SharePlayer,
            meta: {
                title: 'Tone - Playlist Share',
                hideNav: false
            }
        },
        {
            path: '/playlistshare/:playlistId/play/:videoCode/:playlistTitle',
            name: 'SharePlayer',
            component: SharePlayer,
            meta: {
                title: 'Tone - Playlist Share',
                hideNav: false
            }
        },
        {
            path: '/content/work',
            name: 'WorkContents',
            component: WorkContents,
            meta: {
                title: 'Tone - Work Contents',
                hideNav: false
            }
        },
        {
            path: '/content/life',
            name: 'LifeContents',
            component: LifeContents,
            meta: {
                title: 'Tone - Life Contents',
                hideNav: false
            }
        },
        {
            path: '/content/mindbody',
            name: 'MindbodyContents',
            component: MindbodyContents,
            meta: {
                title: 'Tone - Mind-Body Contents',
                hideNav: false
            }
        },
        {
            path: '/content/money',
            name: 'MoneyContents',
            component: MoneyContents,
            meta: {
                title: 'Tone - Money Contents',
                hideNav: false
            }
        },
        {
            path: '/joinnative',
            name: 'JoinNowMobile',
            component: JoinNowMobile,
            meta: {
                title: 'Tone - Login',
                hideNav: false
            }
        },
        {
            path: '/takeaway',
            name: 'Takeaway',
            component: Takeaway,
            meta: {
                title: 'Tone | Takeaway',
                hideNav: false
            }
        },
        {
            path: '/teaser',
            name: 'Teaser',
            component: Teaser,
            meta: {
                title: 'Tone | Teaser',
                hideNav: false
            }
        },
        {
            path: '/resources',
            name: 'ToneResources',
            component: ToneResources,
            meta: {
                title: 'Tone | Resources',
                hideNav: false
            }
        },
        {
            path: '/resources/feature/:feature',
            name: 'ToneResources',
            component: ToneResources,
            meta: {
                title: 'Tone | Resources',
                hideNav: false
            }
        },
        {
            path: '/setthetone/article/:articleId/',
            name: 'SetTONE',
            component: SetTONE,
            meta: {
                title: 'TONE Articles',
                hideNav: false
            }
        },
        {
            path: '/setthetone/article/:articleId/:articleTitle',
            name: 'SetTONE',
            component: SetTONE,
            meta: {
                title: 'TONE Articles',
                hideNav: false
            }
        },
        {
            path: '/corporations/event/live',
            name: 'AMCEvent',
            component: AMCEvent,
            meta: {
                title: 'Tone | Welcome to Event',
                hideNav: false
            }
        },
        {
            path: '/logout',
            name: 'Logout',
            component: Logout,
            meta: {
                title: 'Tone - Logout',
                hideNav: false
            }
        },
        {
            path: '/corporation/mycommunity',
            name: 'CorporateCommunity',
            component: CorporateCommunity,
            meta: {
                title: 'TONE - Community',
                hideNav: false
            }
        },
        {
            path: '/corporation/manage-page',
            name: 'ManagePage',
            component: ManagePage,
            meta: {
                title: 'TONE - Manage Community Page',
                hideNav: false
            }
        },
        {
            path: '/corporation/mycommunity/feature/:tab',
            name: 'CorporateCommunity',
            component: CorporateCommunity,
            meta: {
                title: 'TONE - Community',
                hideNav: false
            }
        },
        {
            path: '/corporation/mycommunity/feature/:tab/section/:section',
            name: 'CorporateCommunity',
            component: CorporateCommunity,
            meta: {
                title: 'TONE - Community',
                hideNav: false
            }
        },
        {
            path: '/sitemaintenance',
            name: 'Maintainance',
            component: Maintainance,
            meta: {
                title: 'Tone - Site Maintenance',
                hideNav: true
            }
        },
        {
            path: '/become-expert',
            name: 'BecomeExpert',
            component: BecomeExpert,
            meta: {
                title: 'Tone | Become Expert Request',
                hideNav: false
            }
        },
        {
            path: '/tone/demo/event',
            name: 'DemoEvent',
            component: DemoEvent,
            meta: {
                title: 'Tone | Event Demo',
                hideNav: false
            }
        },
        {
            path: '/tone/demo/corporate-demo',
            name: 'DemoEventCorp',
            component: CommunityDemo,
            meta: {
                title: 'Tone | Corporation Demo',
                hideNav: false
            }
        },
        {
            path: '/tone/demo/live-event-demo/:eventId',
            name: 'LiveEventDemo',
            component: LiveEventDemo,
            meta: {
                title: 'Tone | Welcome to TONE Event!',
                hideNav: false
            }
        },
        {
            path: '/showpodcast',
            name: 'PodPage',
            component: PodcastTone,
            meta: {
                title: 'PodPage - Anchor',
                hideNav: false
            }
        },
        {
            path: '/drramani',
            name: 'drRamani',
            component: drRamani,
            meta: {
                title: 'Tone - Dr. Ramani Event',
                hideNav: false,
                metaTags: [
                    {
                        name: 'description',
                        content: 'Give the gift of knowledge and inspiration to the women you care about'
                    },
                    {
                        property: 'og:description',
                        content: 'Give the gift of knowledge and inspiration to the women you care about'
                    },
                    {
                        property: 'og:image',
                        content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/experts/Ramani.jpg'
                    },
                    {
                        property: 'og:site_name',
                        content: 'The about page of our example app.'
                    },
                    {
                        property: 'og:title',
                        content: 'Dr. Ramani Event on Narcissism'
                    },
                    {
                        property: 'twitter:title',
                        content: 'Give the gift of knowledge and inspiration to the women you care about'
                    },
                    {
                        property: 'twitter:card',
                        content: 'Dr. Ramani Event on Narcissism'
                    },
                    {
                        property: 'twitter:image',
                        content: 'https://s3.amazonaws.com/assets.tonenetworks.com/images/experts/Ramani.jpg'
                    }
                ]
            }
        },
        // {
        //     path: '/content/:contentCateogry/play/:videoCode',
        //     name: 'Contents',
        //     component: Contents,
        //     meta: {title: 'Tone - Content Category',
        //         hideNav: false}
        // },
        {
            path: '*',
            redirect: '/'
        }
    ]
})
router.beforeEach((to, from, next) => {
    // Sense & Redirect user to site without #
    if (window.location.hash.length > 0) {
        window.location = window.location.hash.substring(1)
    }
    let loggedUser = localStorage.getItem('loggedUser')
    let loggedUserTemp = sessionStorage.getItem('loggedUserTemp') // User needs to be redirected (temporary) after interests are set
    if (loggedUserTemp) {
        loggedUserTemp = JSON.parse(loggedUserTemp)
        store.commit('setUser', { user: loggedUserTemp })
    }
    if (loggedUser) {
        loggedUser = JSON.parse(loggedUser)
        store.commit('setUser', { user: loggedUser })
    }
    let token = localStorage.getItem('token')
    // Check Token is valid and user payload has CC Expiry date for regualr users
    if (token === undefined || !token || token.length < 15 || (loggedUser && !loggedUser.hasOwnProperty('ccExpiryDate')) || (loggedUserTemp && !loggedUserTemp.hasOwnProperty('ccExpiryDate')) || (loggedUser && !loggedUser.hasOwnProperty('ccExpAlarmFlag')) || (loggedUserTemp && !loggedUserTemp.hasOwnProperty('ccExpAlarmFlag'))) { // Old token, user needs to logout and force login
        localStorage.removeItem('loggedUser')
        sessionStorage.removeItem('loggedUserTemp')
        localStorage.removeItem('token')
        sessionStorage.removeItem('token')
        token = null
        loggedUser = null
        loggedUserTemp = null
        store.commit('setUser', { user: null })
    }
    if (to.name === 'Expert') {
        store.commit('setExpert', { expert: null })
        store.commit('setExpertVideos', { expertVideos: null })
        store.commit('setComingVideoFlag', false)
        store.commit('setExpertPlaylist', { playList: null })
    }
    if (to.name === 'PlaylistVideoPlayer' || to.name === 'CorpPlaylistVideoPlayer' || to.name === 'TrendingPlaylistVideoPlayer') {
        store.commit('setUserNewPlaylistObject', { playlist: null })
        store.commit('setTrendingNewPlaylistObject', { playlist: null })
        store.commit('setCorpNewPlaylistObject', { playlist: null })
        store.commit('setExpert', { expert: null })
        store.commit('setItemChangeInPlaylist', { item: null })
    }
    if (to.name === 'ArchivePlayer') {
        store.commit('setArchivePlaylistObject', { eList: null })
        store.commit('setLiveEventsArchive', { liveArchive: null })
        store.commit('setArchivePlaylist', { arplaylist: null })
        store.commit('setItemChangeInPlaylist', { item: null })
        store.commit('setExpert', { expert: null })
    }
    if (to.name === 'Profile') {
        store.commit('setUserPlaylistsProfile', { playlists: null })
        store.commit('setUserProgressProfile', { playlists: null })
        store.commit('setUpcomingEvent', { event: null })
    }
    if (to.name === 'SignUp') {
        if (from.name === 'SharePlayer') {
            if (sessionStorage.getItem('redirectPath')) {
                sessionStorage.removeItem('redirectPath')
                sessionStorage.setItem('redirectPath', from.fullPath)
            } else {
                sessionStorage.setItem('redirectPath', from.fullPath)
            }
        }
    }
    console.log('inside src/router/index.js : loggedUserTemp = ', loggedUserTemp)
    console.log('inside src/router/index.js : loggedUser = ', loggedUser)
    if (loggedUserTemp) { // user is redirecting from login
        if (loggedUserTemp.trialEndDate) {
            let endingDate = new Date(loggedUserTemp.trialEndDate.substr(0, 10))
            let currentDate = new Date()
            let remainingDays = dateHelpers.getDatesDifference(endingDate, currentDate, 'days')
            if (remainingDays >= 0) {
                store.commit('setHeaderAlertStatus', true)
                store.commit('setTrialDays', remainingDays)
            }
            // else {
            //     next({path: '/becomemember'})
            // }
        }
        if (to.name === 'SignUp' || to.name === 'JoinNowMobile' || to.name === 'ResetPassword' || to.name === 'Redeem' || to.name === 'AccentureCharlotte' || to.name === 'CorporationGifting' || to.name === 'CorporationGiftingComcast' || to.name === 'CorporationReferral') {
            next(false)
        } else if (to.name === 'Player' || to.name === 'UnauthPlayer' || to.name === 'NewEvents' || to.name === 'PlaylistVideoPlayer' || to.name === 'CorpPlaylistVideoPlayer') {
            let isDelegated = false
            for (let matched = (to.matched || []), i = matched.length; i--;) {
                let route = matched[i]
                if (route.meta.beforeEach) {
                    isDelegated = true
                    route.meta.beforeEach(to, from, next)
                }
            }
            !isDelegated && next()
            window.scrollTo(0, 0)
            next()
        } else if (to.name === '/' || to.name === 'UnAuth') {
            console.log('R1 - 4', to.name)
            window.scrollTo(0, 0)
            next({ path: '/mytone' })
        } else {
            console.log('R1 - 5')
            window.scrollTo(0, 0)
            document.title = to.meta.title
            next()
        }
    } else {
        if (token && token !== undefined) {
            if (loggedUser.trialEndDate) {
                let endingDate = new Date(loggedUser.trialEndDate.substr(0, 10))
                let currentDate = new Date()
                let remainingDays = dateHelpers.getDatesDifference(endingDate, currentDate, 'days')
                store.commit('setHeaderAlertStatus', true)
                store.commit('setTrialDays', remainingDays)
            }
            if (loggedUser.ccExpiryDate && loggedUser.ccExpAlarmFlag === 2) { // Check if regular user and time left in expiry
                let expiryDate = new Date(loggedUser.ccExpiryDate.substr(0, 10))
                let currentDate = new Date()
                let remainingDays = dateHelpers.getDatesDifference(expiryDate, currentDate, 'days')
                store.commit('setCardExpiryDays', remainingDays)
            }
            if (loggedUser && sessionStorage.getItem('switchClientObject')) { // Corporate User with Switching enabled
                let switchedCorp = sessionStorage.getItem('switchClientObject')
                switchedCorp = JSON.parse(switchedCorp)
                // loggedUser.corporation = null
                // console.log('switching to new corporate -null', loggedUser)
                loggedUser.corporation = switchedCorp // Switch Corporatin Object
                store.commit('setUser', { user: loggedUser }) // Trigger The change
                console.log('current user before switch', loggedUser)
            }
            if (loggedUser.corporation) { // Set Corporation based specific theme for logged user
                // let headerColor = '#f0617d'
                // let footerColor = '#f0617d'
                // let buttonColor = '#f0617d'
                // let headingColor = '#f0617d'
                let headerColor = '#44bda8'
                let footerColor = '#44bda8'
                let buttonColor = '#44bda8'
                let headingColor = '#44bda8'
                if (loggedUser.corporation.groupDefinitions && loggedUser.corporation.groupDefinitions.headerColor) {
                    headerColor = loggedUser.corporation.groupDefinitions.headerColor
                }
                if (loggedUser.corporation.groupDefinitions && loggedUser.corporation.groupDefinitions.footerColor) {
                    footerColor = loggedUser.corporation.groupDefinitions.footerColor
                }
                if (loggedUser.corporation.groupDefinitions && loggedUser.corporation.groupDefinitions.buttonColor) {
                    buttonColor = loggedUser.corporation.groupDefinitions.buttonColor
                }
                if (loggedUser.corporation.groupDefinitions && loggedUser.corporation.groupDefinitions.headingColor) {
                    headingColor = loggedUser.corporation.groupDefinitions.headingColor
                }
                store.commit('setCorpHeaderColor', headerColor)
                store.commit('setCorpFooterColor', footerColor)
                store.commit('setCorpButtonColor', buttonColor)
                store.commit('setCorpHeadingColor', headingColor)
            }
            if (to.name === 'SignUp' || to.name === 'JoinNowMobile' || to.name === 'ResetPassword' || to.name === 'Redeem' || to.name === 'AccentureCharlotte' || to.name === 'CorporationGifting' || to.name === 'CorporationGiftingComcast' || to.name === 'CorporationReferral' || to.name === 'GiftRedirect') {
                next({ path: '/mytone' })
            } else if (to.name === 'Player') {
                let isDelegated = false
                for (let matched = (to.matched || []), i = matched.length; i--;) {
                    let route = matched[i]
                    if (route.meta.beforeEach) {
                        isDelegated = true
                        route.meta.beforeEach(to, from, next)
                    }
                }
                !isDelegated && next()
                window.scrollTo(0, 0)
                next()
            } else if (to.name === '/' || to.name === 'UnAuth') {
                window.scrollTo(0, 0)
                next({ path: '/mytone' })
            } else {
                window.scrollTo(0, 0)
                document.title = to.meta.title
                next()
            }
        } else {
            // console.log('checking the status', to.name)
            // corporateClientObject
            if (localStorage.getItem('corporateClientObject')) { // Corporate User with Switching enabled
                let unauthCorp = localStorage.getItem('corporateClientObject')
                unauthCorp = JSON.parse(unauthCorp)
                if (unauthCorp) { // Set Corporation based specific theme for logged user
                    // let headerColor = '#f0617d'
                    // let footerColor = '#f0617d'
                    // let buttonColor = '#f0617d'
                    // let headingColor = '#f0617d'
                    let headerColor = '#44bda8'
                    let footerColor = '#44bda8'
                    let buttonColor = '#44bda8'
                    let headingColor = '#44bda8'
                    if (unauthCorp.groupDefinitions && unauthCorp.groupDefinitions.headerColor) {
                        headerColor = unauthCorp.groupDefinitions.headerColor
                    }
                    if (unauthCorp.groupDefinitions && unauthCorp.groupDefinitions.footerColor) {
                        footerColor = unauthCorp.groupDefinitions.footerColor
                    }
                    if (unauthCorp.groupDefinitions && unauthCorp.groupDefinitions.buttonColor) {
                        buttonColor = unauthCorp.groupDefinitions.buttonColor
                    }
                    if (unauthCorp.groupDefinitions && unauthCorp.groupDefinitions.headingColor) {
                        headingColor = unauthCorp.groupDefinitions.headingColor
                    }
                    store.commit('setCorpHeaderColor', headerColor)
                    store.commit('setCorpFooterColor', footerColor)
                    store.commit('setCorpButtonColor', buttonColor)
                    store.commit('setCorpHeadingColor', headingColor)
                }
            }
            if (to.name === '/mytone' || to.name === 'Hello' || to.name === 'Player' || to.name === 'Career' || to.name === 'Work' || to.name === 'Life' || to.name === 'Money' || to.name === 'Profile' || to.name === 'Inspiration' || to.name === 'Mindbody' || to.name === 'Rules' || to.name === 'Talk' || to.name === 'LiveEvent' || to.name === 'Giving' || to.name === 'RecentlyWatched' || to.name === 'RelatedVideos' || to.name === 'Events' || to.name === 'CorporateGift' || to.name === 'PlaylistVideoPlayer' || to.name === 'CorpPlaylistVideoPlayer' || to.name === 'CorporateSale' || to.name === 'ArchivePlayer' || to.name === 'Teaser' || to.name === 'Takeaway' || to.name === 'CorporateCommunity' || to.name === 'TrialExpiry' || to.name === 'ManagePage' || to.name === 'TrendingPlaylistVideoPlayer') {
                if (to.fullPath.indexOf('watch') > 0) {
                    if (to.params.refBy && (to.params.refBy.toLowerCase() === 'toneteaser' || to.params.refBy.toLowerCase() === 'tonetakeaway')) {
                        if (to.params.videoTitle) {
                            next({ path: `/contentvideos/play/${to.params.videoCode}/${to.params.refBy.toLowerCase()}/${to.params.videoTitle.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()}` })
                        } else {
                            next({ path: `/contentvideos/play/${to.params.videoCode}/${to.params.refBy.toLowerCase()}` })
                        }
                    } else {
                        if (to.params.videoTitle) {
                            next({ path: `/contentvideos/play/${to.params.videoCode}/${to.params.videoTitle.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase()}` })
                        } else {
                            next({ path: `/contentvideos/play/${to.params.videoCode}` })
                        }
                    }
                } else if (to.fullPath.indexOf('liveevent') > 0 || to.fullPath.indexOf('talk') > 0 || to.fullPath.indexOf('takeaway') > 0 || to.fullPath.indexOf('teaser') > 0 || to.name === 'CorpPlaylistVideoPlayer' || to.name === 'CorporateCommunity' || to.fullPath.indexOf('becomemember') > 0 || to.fullPath.indexOf('tonearchive') > 0 || to.name === 'Events' || to.name === 'PlaylistVideoPlayer' || to.fullPath.indexOf('trending') > 0) {
                    if (sessionStorage.getItem('redirectPath')) {
                        sessionStorage.removeItem('redirectPath')
                        sessionStorage.setItem('redirectPath', to.fullPath)
                    } else {
                        sessionStorage.setItem('redirectPath', to.fullPath)
                    }
                    window.scrollTo(0, 0)
                    console.log('inside src/router/index.js :  ====> to.fullPath = ', to.fullPath)
                    console.log('inside src/router/index.js :  ====> to.name = ', to.name)
                    next({ path: '/' })
                    // store.commit('setTriggerLogin', {loginStatus: true})
                } else {
                    window.scrollTo(0, 0)
                    console.log('inside src/router/index.js : (else) ====> to.fullPath = ', to.fullPath)
                    console.log('inside src/router/index.js : (else) ====> to.name = ', to.name)
                    next({ path: '/' })
                }
            } else {
                window.scrollTo(0, 0)
                document.title = to.meta.title
                next()
            }
        }
    }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js